import { SeriesProcessor } from "./SeriesProcessor";
import {
  CHART_TYPES,
  isCompetitorsChart,
  isMentionsMetricChart,
  isSentimentMetricChart,
  isAmplificationMetricChart,
  isAveMetricChart,
  isReachMetricChart,
} from "./common";
import { MentionChartData } from "~/types/ChartsType";
import { SavedOrNestedSearches } from "~/types/SearchStateType";

const processSeries = (
  metric: string,
  type: string,
  sliceBy: string,
  title: string,
  profilesChartsData: Array<MentionChartData>,
  nestedSearches: SavedOrNestedSearches,
  selectedNestedSearchId: string,
) => {
  const processor = new SeriesProcessor(
    profilesChartsData,
    nestedSearches,
    selectedNestedSearchId,
  );

  switch (type) {
    case CHART_TYPES.BAR:
      if (isReachMetricChart(metric)) {
        return processor.processReachSeries(type, sliceBy);
      }
      if (isAmplificationMetricChart(metric)) {
        return processor.processAmplificationSeries(type, sliceBy);
      }
      if (isAveMetricChart(metric)) {
        return processor.processAveSeries(type, sliceBy);
      }
      if (isMentionsMetricChart(metric)) {
        return processor.processMentionsBarSeries(type, sliceBy);
      }
      if (isSentimentMetricChart(metric)) {
        return processor.processSentimentOverTime(type);
      }
      return [];

    case CHART_TYPES.COLUMN:
      if (isReachMetricChart(metric)) {
        return processor.processReachSeries(type, sliceBy);
      }
      if (isAmplificationMetricChart(metric)) {
        return processor.processAmplificationSeries(type, sliceBy);
      }
      if (isAveMetricChart(metric)) {
        return processor.processAveSeries(type, sliceBy);
      }
      if (isMentionsMetricChart(metric)) {
        return processor.processMentionsColumnSeries(type, sliceBy);
      }
      if (isSentimentMetricChart(metric)) {
        return processor.processSentimentOverTime(type);
      }
      return [];

    case CHART_TYPES.LINE:
      if (isReachMetricChart(metric)) {
        return processor.processReachSeries(type, sliceBy);
      }
      if (isAmplificationMetricChart(metric)) {
        return processor.processAmplificationSeries(type, sliceBy);
      }
      if (isAveMetricChart(metric)) {
        return processor.processAveSeries(type, sliceBy);
      }
      if (isMentionsMetricChart(metric)) {
        return processor.processMentionsBarSeries(type, sliceBy);
      }
      if (isSentimentMetricChart(metric)) {
        return processor.processSentimentOverTime(type);
      }
      return [];

    case CHART_TYPES.PIE:
      if (isCompetitorsChart(sliceBy)) {
        return [
          {
            type,
            name: title,
            data: processor.processCompetitorsPieSeries(metric),
          },
        ];
      }

      if (isAveMetricChart(metric)) {
        return [
          {
            type,
            name: title,
            data: processor.processAvePieSeries(sliceBy),
          },
        ];
      }

      if (isAmplificationMetricChart(metric)) {
        return [
          {
            type,
            name: title,
            data: processor.processAmplificationPieSeries(),
          },
        ];
      }

      if (isReachMetricChart(metric)) {
        return [
          {
            type,
            name: title,
            data: processor.processReachPieSeries(sliceBy),
          },
        ];
      }

      return [
        {
          type,
          name: title,
          data: processor.processMentionsPieSeries(sliceBy),
        },
      ];

    default:
      return [];
  }
};

export { processSeries };
